import {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  GridValueGetterParams,
  GridColDef,
  GridActionsCellItem,
  DataGrid,
  GridToolbar,
} from "@mui/x-data-grid";

import { useNavigate, useParams } from "react-router-dom";
import Link from '@mui/material/Link';
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box/Box";
import { Button, Drawer, IconButton, InputAdornment, TextField, Tooltip, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';

import CheckIcon from '@mui/icons-material/Check';
import CrossIcon from '@mui/icons-material/Close';

import {
  useAppDispatch,
  useAppSelector,
} from '../../store/hooks';

import CustomDataGrid from '../../components/DataGrid/DataGrid';
import BreadCrum from "../../components/Breadcrumbs/Breadcrumbs";
import { Utils } from "../../utils/common-utils";
import { /* deleteUser,  */fetchCustomers, fetchCustomersWithFilters, updatePartyStatus } from '../../store/customerStore/customerThunk';
import { /* IRole, */ ICustomerDetails } from "../../utils/customer.types";
import { PermissionsEnum } from "../../utils/auth.types";
import { ApiStatus, apiLimit, defaultRowsPerPageOptions } from "../../utils/api.types";
import EditIcon from '@mui/icons-material/Edit';
import RemoveRedEyeTwoToneIcon from '@mui/icons-material/RemoveRedEyeTwoTone';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

import NavigateBeforeOutlinedIcon from '@mui/icons-material/NavigateBeforeOutlined';
import DialogClientUpdateForm from '../Dialog/UpdateClientForm';


import { Avatar, Card, CardContent, Grid } from "@mui/material";
import { SearchIcon } from 'lucide-react';


/**
 * Components to show customers list in the data grid.
 */
const CustomerList = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { accountId = '' } = useParams();

  const { permissions, selectedAccount } = useAppSelector(state => state.auth);
  const { customers, status, rowCount } = useAppSelector(state => state.customers);

  //const canCreateUsers = permissions?.includes(PermissionsEnum.Users_Create);
  // const canUpdateUsers = permissions?.includes(PermissionsEnum.Users_Update);
  //const canViewUsers = permissions?.includes(PermissionsEnum.Users_View);
  // const canDeleteUsers = permissions?.includes(PermissionsEnum.Users_Delete);

  const [open, setOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const canUpdateAccount = permissions?.includes(PermissionsEnum.Account_Update);

  const [openCustomerDrawer, setOpenCustomerDrawer] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState<any>('');

  const [filterQuery, setFilterQuery] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // handle pagination
  const [page, setPage] = useState(0); // Current page (0-based index)
  const [pageSize, setPageSize] = useState(apiLimit.limit); // Rows per page
  const [pageQueryString, setPageQueryString] = useState(`page=0`); // Current page (0-based index)
  const [pageSizeQueryString, setPageSizeQueryString] = useState(`&limit=${apiLimit.limit}`); // Rows per page

  /**
  * Handler for Customer name click.
  */
  const handleEditClick = useCallback(({ _id }: ICustomerDetails) => {
    //Call edit function
    let navLink = `/customer/edit/${_id}`;
    navigate(navLink);

  }, []);

  const handleViewClick = useCallback(({ _id }: ICustomerDetails) => {
    //Call view function
    let navLink = `/customer/view/${_id}`;
    navigate(navLink);

  }, []);

  /**
   * Fetch all the customers list on user's page load.
   */
  useEffect(() => {
    // Fetch account related customers if we are loading users on account details page.
    fetchCustomersList1();

  }, [dispatch, selectedAccount, accountId, isEdit, filterQuery, page, pageSize, pageQueryString, pageSizeQueryString]);


  const fetchCustomersList = () => {
    if (accountId) {
      dispatch(fetchCustomersWithFilters({ accountId: accountId, params: filterQuery + pageQueryString + pageSizeQueryString }));
    } else if (selectedAccount) {
      const { _id: id } = selectedAccount;
      dispatch(fetchCustomersWithFilters({ accountId: id, params: filterQuery + pageQueryString + pageSizeQueryString }));
    }
  }

  const fetchCustomersList1 = async () => {
    const { _id: id } = selectedAccount;
    if (filterQuery) {
      let filter = (filterQuery && filterQuery !== '') ? `&name=${filterQuery}` : '';
      await dispatch(fetchCustomersWithFilters({ accountId: id, params: pageQueryString + pageSizeQueryString + filter }));
      setIsLoading(false);
    } else {
      await dispatch(fetchCustomersWithFilters({ accountId: id, params: pageQueryString + pageSizeQueryString }));
      setIsLoading(false);
    }
  }

  // Handle utility functions 

  const handleOpenCustomerDrawer = (event: any, isCustomerEdit: boolean, row: ICustomerDetails | undefined) => {
    console.log("handleOpenCustomerDrawer called");
    console.log(isCustomerEdit);
    setIsEdit(isCustomerEdit);
    setSelectedCustomer(row)
    setOpenCustomerDrawer(true);
    event.stopPropagation();
  };
  
  const [deactivateDialogOpen, setDeactivateDialogOpen] = useState(false);
  const [partyToDeactivate, setPartyToDeactivate] = useState<any>(null);

  const handleDeactivateClick = (event: any, row: any) => {
    event.stopPropagation();
    setPartyToDeactivate(row);
    setDeactivateDialogOpen(true);
  };

  const confirmDeactivate = async () => {
    if (partyToDeactivate) {
      await dispatch(updatePartyStatus({ 
        partyId: partyToDeactivate._id, 
        isActive: false 
      }));
      setDeactivateDialogOpen(false);
      setPartyToDeactivate(null);
      fetchCustomersList1(); // Refresh list
    }
  };

  const handleCloseCustomerDrawer = async (val: any) => {
    setIsEdit(false);
    setSelectedCustomer('');
    setOpenCustomerDrawer(false);
    console.log(val);
    if (val) {
      fetchCustomersList()
    }
  };

  const cancelDialog = () => {
    // setIsClientLoading(false); 
    // setSelectedAgent(false); 
    // setIsAgentLoading(false); 
    // setIsLoading(false);
  }

  // Define Users data grid column defs.
  const columns: GridColDef[] = useMemo(() => [
    {
      field: "name",
      headerName: 'Name',
      type: "string",
      flex: 2,
      renderCell: ({ row }: GridValueGetterParams) => (
        <Box sx={{ width: '100%', py: 0.5 }}>
          <Grid container sx={{ justifyContent: 'left', alignItems: 'center' }} spacing={1} wrap="nowrap">
            <Grid item>
              <Avatar
                alt={row.legalName?.toUpperCase()}
                imgProps={{ "referrerPolicy": 'no-referrer' }}
                src={`${row.logo}`}
              />
            </Grid>
            <Grid item xs sx={{ minWidth: 0 }}>
              <Tooltip title={row.legalName}>
                <Typography
                  onClick={() => handleViewClick(row)}
                  sx={{
                    cursor: 'pointer',
                    wordWrap: 'break-word',
                    wordBreak: 'break-word',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    lineHeight: 1.3,
                    maxWidth: '300px',
                    '&:hover': {
                      textDecoration: 'underline'
                    }
                  }}
                >
                  {row.legalName}
                </Typography>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
      )
    },
    {
      field: "taxIdentificationNumber2",
      headerName: 'GST',
      type: "string",
      flex: 1,
      renderCell: ({ row, value }: GridValueGetterParams) => (
        <Typography>{value}</Typography>
      )
    },
    {
      field: "contacts",
      headerName: 'Contact Name',
      type: "string",
      flex: 1,
      // width:300,
      renderCell: ({ row, value }: GridValueGetterParams) => (
        <>
          <Tooltip title={row.contactName}>
            <Typography>{row.contactName} <br /> {row.whatsAppNumber}</Typography>
          </Tooltip>
        </>
      )
    },
    // {
    //   field: "addresses",
    //   headerName: 'Address',
    //   type: "string",
    //   flex: 2,
    //   renderCell: ({ row, value }: GridValueGetterParams) => (
    //     {
    //       let address = (type === 'account-receivable') ? selectedClient.addresses : selectedBuyer.addresses;
    //       let shippingAddress = address.find((item: any) => item.type === 'Shipping');
    //       let billingAddress = address.find((item: any) => item.type === 'Billing');
    //     }
    //     <>
    //       <Tooltip title={row.email.join(", ")}> 
    //         <Typography>{row.addresses[0].line1}</Typography>
    //       </Tooltip> 
    //     </>
    //   )
    // },
    // {
    //   field: "legalName",
    //   headerName: 'Legal Name',
    //   type: "string",
    //   flex: 2,
    //   renderCell: ({ row, value }: GridValueGetterParams) => (
    //     <Typography>
    //       <Grid container sx={{ justifyContent: 'left', alignItems: 'left' }} spacing={1}>
    //         <Grid item style={{textAlign: "center"}}>
    //         <Tooltip title={value}> 
    //           <Typography>{value} </Typography></Tooltip> 
    //         </Grid>
    //       </Grid>
    //     </Typography>
    //   )
    // },
    // {
    //   field: 'companyDesc',
    //   headerName: 'Company Description',
    //   type: "string",
    //   flex: 2,
    //   valueGetter: ({ value }: GridValueGetterParams) => {
    //     return value
    //   }
    // },
    {
      field: "totalTransaction",
      headerName: 'Total Transaction',
      type: "number",
      flex: 1,
      align: 'right',
      headerAlign: 'right',
      renderCell: ({ row, value }: GridValueGetterParams) => (
        <div style={{ width: '100%', textAlign: 'right' }}>
          <span style={{
            fontWeight: 600,
            color: value > 0 ? 'inherit' : '#9e9e9e'
          }}>
            {Utils.formatNumber(value || 0, false)}
          </span>
        </div>
      )
    },
    {
      field: "totalPaidReceived",
      headerName: 'Paid amount',
      type: "number",
      flex: 1,
      align: 'right',
      headerAlign: 'right',
      renderCell: ({ row, value }: GridValueGetterParams) => {
        const outstanding = row.outstandingBalance;
        const isAdvance = outstanding < 0;
        return (
          <div style={{ width: '100%', textAlign: 'right' }}>
            <span style={{
              fontWeight: 600,
              color: value > 0 ? '#2e7d32' : '#9e9e9e'
            }}>
              {Utils.formatNumber(value || 0, false)}
            </span>
            {isAdvance && (
              <div style={{ fontSize: '10px', color: '#488dff', fontWeight: 600 }}>
                (Adv. {Utils.formatNumber(Math.abs(outstanding), false)})
              </div>
            )}
          </div>
        )
      }
    },
    {
      field: "toCollect",
      headerName: 'To Collect',
      type: "number",
      flex: 1,
      align: 'right',
      headerAlign: 'right',
      renderCell: ({ row }: GridValueGetterParams) => {
        const value = row.outstandingBalance;
        return (
          <div style={{ width: '100%', textAlign: 'right' }}>
            <span style={{
              fontWeight: 600,
              color: value > 0 ? '#d32f2f' : '#9e9e9e'
            }}>
              {value > 0 ? Utils.formatNumber(value, false) : Utils.formatNumber(0, false)}
            </span>
          </div>
        )
      }
    },
    {
      field: "status",
      headerName: 'Status',
      type: "string",
      flex: 0.6,
      renderCell: ({ row, value }: GridValueGetterParams) => (
        <Typography>
          <Grid container sx={{ justifyContent: 'left', alignItems: 'center', width: "500px" }} spacing={1}>
            <Grid item >
              <Tooltip title={row.isActive == true ? 'Active' : 'Inactive'}>
                <Typography>{row.isActive == true ? <CheckIcon color="success" /> : <CrossIcon color="error" />}</Typography>
              </Tooltip>
            </Grid>
            <Grid item sx={{ justifyContent: 'center', alignItems: 'center' }} style={{ textAlign: "center" }}>
              <Tooltip title={row.refToAccount ? 'Verfied' : 'Not Verified'}>
                <Typography>{row.refToAccount ? <CheckIcon color="success" /> : <CrossIcon color="error" />}</Typography>
              </Tooltip>
            </Grid>
          </Grid>
        </Typography>
      ),
    },
    // {
    //   field: "verifiedStatus",
    //   headerName: 'Is Verified',
    //   type: "string",
    //   renderCell: ({ row, value }: GridValueGetterParams) => {
    //     return <div className="flex-column padIcon30">{row.refToAccount ? <CheckIcon/>: <CrossIcon/>}</div>
    //   },
    //   flex: 2
    // },
    // {
    //   field: "isActive",
    //   headerName: 'Is Active',
    //   type: "string",
    //   renderCell: ({ row, value }: GridValueGetterParams) => (
    //     <div className="flex-column padIcon">{value == true ? <CheckIcon/>: <CrossIcon/>}</div>
    //   ),
    //   flex: 2
    // },
    {
      field: "actions",
      headerName: 'Actions',
      type: "string",
      flex: 1,
      renderCell: ({ row, value }: GridValueGetterParams) => (
        <>
          <IconButton
            style={{ color: '#488dff', backgroundColor: '#fff', border: '0.1px solid #488dff', height: 35, width: 35, marginRight: 10 }}
            size='small' onClick={() => handleViewClick(row)} ><RemoveRedEyeTwoToneIcon style={{ fontSize: 16 }} />

          </IconButton>
          <IconButton
            style={{ color: '#49a563', backgroundColor: '#edf6ef', border: '0.1px solid #49a563', height: 35, width: 35, marginRight: 10 }}
            size='small' onClick={(e) => handleOpenCustomerDrawer(e, true, row)}><EditIcon style={{ fontSize: 16 }} />

          </IconButton>
          <Tooltip title="Deactivate Party">
            <IconButton
              style={{ color: '#d32f2f', backgroundColor: '#fff', border: '0.1px solid #d32f2f', height: 35, width: 35 }}
              size='small' onClick={(e) => handleDeactivateClick(e, row)}><DeleteIcon style={{ fontSize: 16 }} />
            </IconButton>
          </Tooltip>
        </>
      )
    },


    // {
    //   field: "actions",
    //   headerName: 'Actions',
    //   type: "actions",
    //   flex: 1,
    //   getActions: (params: GridValueGetterParams) => {
    //     const editAction = (
    //         <GridActionsCellItem
    //             icon={<EditIcon color="success"/>}
    //             title="Edit"
    //             label="Edit"
    //             onClick={(e) => handleOpenCustomerDrawer(e, true, params.row)} />
    //     );

    //     const deleteAction = (
    //     <GridActionsCellItem
    //         icon={<DeleteIcon/>}
    //         title="Delete"
    //         label="Delete"
    //         disabled
    //         // onClick={deleteSelectedAddress(params.row)}
    //     />
    //     );

    //     const actions: JSX.Element[] = [];

    //     // Push edit action if user has update permission.
    //     if (canUpdateAccount) {
    //     actions.push(editAction);
    //     }
    //     // Push edit action if user has delete permission.
    //     if (true) {
    //     actions.push(deleteAction);
    //     }
    //     return actions;
    //   }
    // }  
  ], []);

  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  const searchQuery = async (searchValue: string) => {
    // setIsLoading(true);
    setFilterQuery(searchValue);
  }

  // Handle page change
  const handlePageChange = (newPage: number) => {
    // page = newPage;
    setPage(newPage);
    setPageQueryString(`&page=${newPage}`);
  };

  // Handle page size change
  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
    setPageSizeQueryString(`&limit=${newPageSize}`);
  };

  return (
    <>
      <Typography className={'cardHeader'} variant="h4" component="div">

        <Box sx={{ display: "flex", justifyContent: "end", paddingTop: '8px', width: '100%' }}>
          <div style={{ display: "flex", flexDirection: 'row', justifyContent: 'flex-start', flex: 1, alignItems: "flex-start", textAlign: "start" }}>
            <TextField className='c-text-field-4'
              variant="standard"
              style={{ width: '40%', marginTop: 10 }}
              size='small'
              // value={filterQuery}
              placeholder='Search by Leagal Name, GST No, Phone, Email ...'
              onChange={(e) => searchQuery(e.target.value.toString())}
              InputProps={{
                disableUnderline: true,
                startAdornment: <InputAdornment position="start"><SearchIcon style={{ marginTop: -3 }} size={20} /></InputAdornment>,
                style: {
                  fontSize: 14,
                  fontWeight: 'normal',
                },
              }}
            />
          </div>
          <div style={{ float: 'right', marginTop: 10, marginRight: 10 }}>
            <Button
              startIcon={<AddIcon />}
              size='small'
              onClick={(e) => handleOpenCustomerDrawer(e, false, undefined)}
              style={{ color: '#488dff', backgroundColor: '#fff', border: '0.5px solid #488dff', height: 35, borderRadius: 7 }}
              variant="contained"
            >
              Create New Buyer
            </Button>
          </div>
        </Box>
      </Typography>
      <div style={{ height: "85vh", width: "100%", marginTop: '0px', overflow: 'auto', paddingRight: 10 }}>
        <CustomDataGrid
          rowCount={rowCount}
          rowsPerPageOptions={defaultRowsPerPageOptions}
          page={page}
          pageSize={pageSize}
          onPageSizeChange={handlePageSizeChange}
          onPageChange={handlePageChange}
          columns={columns}
          rows={customers}
          getRowId={(row) => row._id}
          loading={status === ApiStatus.LOADING}
        />
      </div>
      <DialogClientUpdateForm
        title={'Buyer'}
        open={openCustomerDrawer}
        onClose={handleCloseCustomerDrawer}
        onCancel={cancelDialog}
        selectedData={selectedCustomer}
        isClientEdit={isEdit}
      >
      </DialogClientUpdateForm>

      {/* Deactivation Confirmation Dialog */}
      <Dialog
        open={deactivateDialogOpen}
        onClose={() => setDeactivateDialogOpen(false)}
      >
        <DialogTitle sx={{ fontWeight: 600, color: '#d32f2f' }}>Deactivate Party?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to deactivate <b>{partyToDeactivate?.legalName}</b>?<br /><br />
            If a party is inactive, it will not be visible for further business operations.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ pb: 2, px: 3 }}>
          <Button onClick={() => setDeactivateDialogOpen(false)} sx={{ color: '#9e9e9e' }}>Cancel</Button>
          <Button onClick={confirmDeactivate} variant="contained" color="error" autoFocus sx={{ borderRadius: 2 }}>
            Deactivate
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default CustomerList;
